import { validate360User } from '../services';
export async function validateAppUser(pin, token) {
    const response = await validate360User(pin, token);
    return formatResponse(response);
}
function formatResponse({ success, errors, data }) {
    if (!success) {
        return {
            success: false,
            error: errors.code,
        };
    }
    return {
        success: true,
        data: {
            id: data.id,
            name: data.name,
            store: data.store,
            profile: data.profile,
            imported: data.imported,
            createdAt: data.created_at,
            accessToken: data.access_token,
        },
    };
}
